<app-header
  icon="fas fa-map"
  text="Kartenstandards"
  sub="Definieren Sie die Grundeinstellungen Ihrer Karten."></app-header>
<p-divider />

<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header icon="fas fa-palette" text="Hintergrund und Farben"></app-header>
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Kartenhintergrund'"
      [name]="'tileLayer'"
      [colSize]="6">
      <p-dropdown
        formControlName="tileLayer"
        name="direction"
        [options]="leafletTileLayerOptions"></p-dropdown>
    </app-form-field-wrapper>
    <app-colorset-dropdown
      [colSize]="5"
      formControlName="colorset"></app-colorset-dropdown>
  </div>
  <p-divider />
  <div class="grid" formGroupName="captions">
    <div class="col-6">
      <app-header icon="fas fa-a" text="Beschriftung einblenden"></app-header>
      <div class="grid align-items-start">
        <div class="col-3 flex-column flex gap-2">
          <div class="flex align-items-center">
            <p-checkbox
              formControlName="key"
              [binary]="true"
              label="Schlüssel"
              name="key" />
          </div>
          <div class="flex align-items-center">
            <p-checkbox
              formControlName="name"
              [binary]="true"
              label="Name"
              name="name" />
          </div>
          <div class="flex align-items-center">
            <p-checkbox
              formControlName="value"
              [binary]="true"
              label="Wert"
              name="value" />
          </div>
          <div class="flex align-items-center">
            <p-checkbox
              formControlName="chart"
              [binary]="true"
              label="Diagramm"
              name="chart" />
          </div>
        </div>
        <!--<app-form-field-wrapper
          [label]="'Ausrichtung'"
          [name]="'direction'"
          [colSize]="4">
          <p-dropdown
            formControlName="direction"
            name="direction"
            [options]="leafletLabelDirectionOptions"></p-dropdown>
        </app-form-field-wrapper>-->
      </div>
    </div>
    <div class="col-6">
      <app-header
        text="Positionierung"
        icon="fas fa-arrows-to-circle"></app-header>
      <div class="grid">
        <app-form-field-wrapper
          [floatingLabel]="false"
          [hideLabel]="true"
          name="style"
          [colSize]="12">
          <p-dropdown
            formControlName="style"
            [options]="mapTooltipStyleDropdownItems">
            <ng-template let-item pTemplate="selectedItem">
              <app-dropdown-option [item]="item" />
            </ng-template>
            <ng-template let-item pTemplate="item">
              <app-dropdown-option [item]="item" />
            </ng-template>
          </p-dropdown>
        </app-form-field-wrapper>
      </div>
    </div>
  </div>

  <p-divider />
  <app-header
    icon="fas fa-map-location-dot"
    text="Räume und Standorte"></app-header>

  <div class="grid">
    <!--<div class="col-4">
      <label class="mb-2 inline-block">Teilraumsumrandung</label>
      <app-ngx-slider
        [options]="{ ceil: strokeColors.length - 1, translate: hexToFas }"
        formControlName="strokeColor"></app-ngx-slider>
    </div>-->
    <div class="col-5">
      <label class="mb-2 inline-block">Transparenz der Räume</label>
      <app-ngx-slider
        labelCeil="gering"
        labelFloor="hoch"
        [options]="{ floor: 0.1, ceil: 0.9, step: 0.1 }"
        formControlName="districtOpacity"></app-ngx-slider>
    </div>
    <div class="col-5">
      <label class="mb-2 inline-block">Icon-Größe der Standorte</label>
      <app-ngx-slider
        labelFloor="klein"
        labelCeil="groß"
        [options]="{ floor: 0.5, ceil: 2, step: 0.1 }"
        formControlName="poiSize"></app-ngx-slider>
    </div>
  </div>
  <p-divider />
  <app-header icon="fas fa-list-ul" text="Legende und Klassen"></app-header>
  <div formGroupName="legend">
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Legendenausrichtung'"
        [name]="'size'"
        [colSize]="4">
        <p-dropdown
          name="size"
          [options]="mapLegendOptions"
          formControlName="size"></p-dropdown>
      </app-form-field-wrapper>
      <app-form-field-wrapper name="position" [colSize]="4" label="Position">
        <p-dropdown
          formControlName="position"
          [options]="mapLegendPositionOptions">
        </p-dropdown>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'Anzahl der Klassen'"
        [name]="'numberOfScales'"
        [colSize]="2">
        <p-inputNumber
          id="numberOfScales"
          type="number"
          formControlName="numberOfScales"></p-inputNumber>
      </app-form-field-wrapper>
    </div>
    <div class="grid mt-3">
      <app-form-field-wrapper
        [floatingLabel]="false"
        [label]="'Klasseneinteilung'"
        [name]="'numberOfScales'"
        [colSize]="6">
        <div class="flex gap-4">
          <p-radioButton
            name="scaleMode"
            value="width"
            label="gleiche Klassenbreiten"
            formControlName="scaleMode"
            inputId="scaleMode" />
          <p-radioButton
            name="scaleMode"
            value="count"
            label="gleiche Klassenbesetzung"
            formControlName="scaleMode"
            inputId="scaleMode" />
        </div>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [floatingLabel]="false"
        [label]="'Klassen bei gruppierten Räumen'"
        [name]="'numberOfScales'"
        [colSize]="6">
        <div class="flex gap-4">
          <p-radioButton
            name="legendScope"
            value="all"
            label="gesamter Raum"
            formControlName="legendScope"
            inputId="legendScope" />
          <p-radioButton
            name="legendScope"
            value="group"
            label="pro Gruppe"
            formControlName="legendScope"
            inputId="legendScope" />
        </div>
      </app-form-field-wrapper>
    </div>
  </div>
</form>
